import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../utils/util';
import { updateCommonData, RELOAD_ENTRY } from '../actions';
import { bindActionCreators } from 'redux';

class WS extends Component {
    constructor(props) {
        super(props);
        this.container = null;
    }

    /* Lifecycle Events */
    componentDidMount() {
        const data = { ...this.props.data, ...this.props.data.contents };
        const device = window.platform && window.platform.type ? 'tablet' : null;
        this.initOption = {
            type: 'workspace',
            fonts: EntryStatic.fonts,
            libDir: '/lib',
            device: device,
            loadInterface: true,
            doCommandAll: false,
            commentDisable: true,
            backpackDisable: true,
        };

        Object.assign(this.initOption, data.injectOption);

        if (Entry.type && Entry.type !== 'invisible') {
            Entry.changeContainer(this.container);
            Entry.reloadOption(this.initOption);
        } else {
            Entry.init(this.container, this.initOption);
        }

        this.loadData(data);
    }

    componentDidUpdate(prevProps) {
        const data = { ...this.props.data, ...this.props.data.contents };
        const previousId = prevProps.data ? prevProps.data._id : '';
        const isReloadAction = !prevProps.common.reload && this.props.common.reload;
        //reloadEntry
        if (isReloadAction) {
            this.reloadEntry();
            this.props.actions.updateCommonData(RELOAD_ENTRY, false);
            return;
        }

        if (previousId !== data._id || data.isNew) {
            if (this.props.data.injectOption) {
                Entry.reloadOption({ commentDisable: true, backpackDisable: true, ...data.injectOption });
            }
            this.loadData(data);
        }
    }

    reloadEntry = () => {
        const temp = Entry.exportProject();
        Entry.clearProject();
        Entry.disposeContainer();
        Entry.reloadBlock();
        Entry.init(this.container, this.initOption);
        Entry.loadProject(temp);
    };

    loadData(data) {
        const { basicProject, injectOption={}, isNew } = data;
        const { viewCategory, lockBasicBlocks, objectEditable } = injectOption;
        if (!basicProject) return;

        Entry.clearProject();
        this.setAvailableBlocks(data, viewCategory);
        if (!objectEditable) {
            basicProject.objects.forEach((o) => (o.lock = true));
        }
        if (isNew && lockBasicBlocks) {
            this.lockDefaultBlocks(basicProject);
        }
        Entry.loadProject(basicProject);
        Entry.scene.selectScene();
        // if (!Entry.objectEditable)
        //     Entry.container.mapObject((o) => o.disableContextMenu);
    }

    setAvailableBlocks(data, isSetCategory = false) {
        $('.entryCategoryListWorkspace').remove();
        const { availableBlocks = [{ category: 'start', 'blocks': [] }] } = data;
        const blockJSON = Util.appendDefaultHardWareMenu(availableBlocks);
        const blockMenu = Entry.getMainWS().blockMenu;
        if (isSetCategory) {
            blockMenu.setCategoryData(blockJSON);
        } else {
            blockMenu.setNoCategoryData(Util.generateBlocks(blockJSON));
        }
        //Util.unbanHW();
        blockMenu.disableMouseEvent = false;
    }

    lockDefaultBlocks(basicProject) {
        basicProject.objects.map(function(o) {
            var scriptJSON = JSON.parse(o.script);
            scriptJSON.map(Util.lockThread);
            o.script = JSON.stringify(scriptJSON);
        });
    }
    /* Events Handler */

    render() {
        return <div ref={(div) => {
            this.container = div;
        }}/>;
    }
}

WS.displayName = 'WS';
WS.defaultProps = {
    data: {
        title: '',
        isHomework: false,
        isHomeworkLapse: false,
        isLastStudy: false,
    },
};

const mapStateToProps = (state) => ({
    ...state,
});

function mapDispatchToProps(dispatch) {
    const actions = { updateCommonData };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WS);



// WEBPACK FOOTER //
// ./components/Workspace.js